import "./style.css";
import { Link, Router, useNavigate } from "react-router-dom";

// Creator : Team A - Shahar

/**
 *
 * @param {{content : string , title:string , link:string} } props
 * @returns
 */

function SubTitleLogin({ content, link, title, sign, color = "black" }) {
  const navigate = useNavigate()
  return (
    <div className="sub-title-box">
      <div>
        <h4> {title}</h4>
      </div>
      <div className="sub-title ">
        <p style={{ color }}>  {content}</p>
        {link && <div onClick={() => navigate(link)}> Sign {sign} </div>}
      </div>
    </div>
  );
}

export default SubTitleLogin;
